export default __webpack_public_path__ + "static/media/airdockz-wht-3.08772f01.png";